<template>
  <div class="ai-friend-role">
    <ConfigTable ref="ct" :searchConfig="searchConfig" :tableColumns="tableColumns" :tableData="list" :total="total"
      @change="loadData" @edit="edit" @add="add" @sync="sync" @delete="deleteRow"></ConfigTable>
    <EditRole ref="editDialog" @sure="callEdit"></EditRole>
  </div>
</template>

<script>
import { Switch } from 'element-ui';
import { changeDate, changeMd } from '../../../utils/filter';
import ConfigTable from '@/components/config-table';
import Gallery from '@/components/gallery';
import aiFriendApi from '../../../api/aiFriendManage';
import EditRole from './components/EditRole.vue';
import { genderTypes, getLabelTextWithValue, toggleOptions } from '../../config';
import LongText from './components/LongText.vue';

const searchConfig = [
  { type: 'input', placeholder: '输入角色名称', key: 'name' },
  { type: 'select', placeholder: '选择角色性别', key: 'gender', options: genderTypes },
  { type: 'select', placeholder: '是否开启角色', key: 'status', options: toggleOptions },
  { type: 'button', icon: 'search', placeholder: '搜索', key: 'search' },
  { type: 'button', icon: 'plus', placeholder: '新增', key: 'add' },
  { type: 'button', icon: 'refresh', placeholder: '同步', key: 'sync' },
]

const tableColumns = [
  { name: 'ID', key: 'id', width: 220, fixed: 'fixed' },
  { name: '名称', key: 'name' },
  {
    name: '头像', key: 'avatar', component: Gallery, props: (val) => ({ list: val })
  },
  {
    name: '写真图', key: 'portrait', component: Gallery, props: (val) => ({ list: val })
  },
  { name: '年龄', key: 'age' },
  {
    name: '个人简介', key: 'bio', width: 250, component: LongText, props(value) {
      return { text: value }
    }
  },
  { name: '性别', key: 'gender', valueHandler: (val) => getLabelTextWithValue(genderTypes, val) },
  { name: '职业', key: 'occupation', valueHandler: (val) => val || '-' },
  { name: '性格', key: 'personality', valueHandler: (val) => val || '-' },
  { name: '兴趣爱好', key: 'hobbies', valueHandler: (val) => (val && val.length > 0) ? val.join('、') : '-' },
  { name: '当前心情', key: 'mood' },
  { name: '语音类型', key: 'voice' },
  {
    name: '自定义标签', key: 'customTags', valueHandler(val, item) {
      if (item.customDetailTags) return item.customDetailTags.map(v => v.name).join('、')
      return '-'
    }
  },
  { name: '聊天风格', key: 'chatStyle' },
  { name: '聊天次数', key: 'chatCount' },
  { name: '解锁次数', key: 'unlockCount' },
  { name: '关系状态', key: 'relationship' },
  {
    name: '个性化设置', key: 'settings', component: LongText, props(value) {
      return { text: value }
    }
  },
  {
    name: '是否高级角色', key: 'isPremium', component: Switch, props(value) {
      return { value, disabled: true }
    }
  },
  { name: '点赞次数', key: 'likeCount' },
  { name: '最后活跃时间', key: 'lastActive', valueHandler: changeMd },
  {
    name: '创建时间', key: 'createdAt', valueHandler: changeDate
  },
  {
    name: '更新时间', key: 'updatedAt', valueHandler: changeDate
  },
  { name: '操作', fixed: 'right', actions: ['edit', 'delete'] },
];

export default {
  name: 'AiFriendRoleManage',
  components: { ConfigTable, EditRole },
  data() {
    return {
      searchConfig,
      tableColumns,
      total: 0,
      list: [],
    };
  },
  watch: {

  },
  mounted() {

  },
  methods: {
    async loadData(params) {
      try {
        const r = await aiFriendApi.getAiRoleList(params)
        const data = r.data
        this.total = data.total
        this.list = data.list
      } catch (error) {
        console.error('搜索ai角色失败：', error);
      }
    },
    add() {
      this.$refs.editDialog.open()
    },
    async sync() {
      try {
        await this.$confirm('您确定要同步角色吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        })
        const r = await aiFriendApi.syncAiList()
        console.log(r);
        this.$message({ message: r.data, type: 'success' })
      } catch (error) {
        if (typeof error !== 'string') {
          this.$message({ message: '同步失败', type: 'error' })
          console.error('sync error:', error);
        }
      }
    },
    edit(row) {
      this.$refs.editDialog.open(row)
    },
    async deleteRow(row) {
      try {
        await this.$confirm("您确定要删除该条数据吗？", "操作提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        await aiFriendApi.delAiRole({ id: row.id })
        this.$message.success('已删除')
        this.$refs.ct.search()
      } catch (error) {
        console.log(error);
      }
    },
    async callEdit(r) {
      try {
        console.log(r);
        await (r.isEdit ? aiFriendApi.updateAiRole(r.data) : aiFriendApi.createAiRole(r.data))
        this.$message.success(r.isEdit ? '更新成功' : '新增成功')
        this.$refs.editDialog.close()
        setTimeout(() => {
          this.$refs.ct.search()
        }, 200);
      } catch (error) {
        console.error('call edit error:', error);
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.ai-friend-role {

  /deep/ .el-button {
    padding: 9px 15px;
  }

  /deep/ .el-image {
    width: 100px;
    height: 100px;

    img {
      object-fit: contain;
    }
  }
}
</style>